import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MainContainer } from '../MainContainer';
import { getOfficeOwners, createOfficeOwner, updateOfficeOwner, deleteOfficeOwner } from '../../actions/officeOwnerAction';
import { getUsers } from '../../actions/user.actions';
import { getOffices } from '../../actions/officeAction';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import OfficeOwnerList from './OfficeOwnerList';
import OfficeOwnerFormModal from './OfficeOwnerFormModal';
import Loader from '../../components/Loader';

const OfficeOwnerPage = () => {
    const dispatch = useDispatch();
    const { owners, ownerLoading, ownerError } = useSelector((state) => state.officeOwner);
    const { user, authenticate } = useSelector((state) => state.auth);
    const [showModal, setShowModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [formItem, setFormItem] = useState({ userId: '', offices: [] });

    useEffect(() => {
        dispatch(getOfficeOwners());
        dispatch(getUsers());
        dispatch(getOffices());
    }, [dispatch, authenticate, user.role]);

    const handleOpenModal = (owner = null) => {
        setCurrentId(owner?._id || null);
        setFormItem({
            userId: owner?.userId?._id || '',
            offices: owner?.offices?.map((office) => office._id) || [],
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentId(null);
        setFormItem({ userId: '', offices: [] });
    };

    const handleSubmit = async () => {
        try {
            if (currentId) {
                await dispatch(updateOfficeOwner(currentId, formItem));
            } else {
                await dispatch(createOfficeOwner(formItem));
            }
            dispatch(getOfficeOwners());
            handleCloseModal();
        } catch (error) {
            alert(error.payload?.error || 'Ошибка сохранения владельца');
        }
    };

    if (ownerLoading) {
        return <Loader />;
    }

    return (
        <MainContainer type="add" title="Настройки владельцев офисов">
            <Row>
                <Col>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleOpenModal()}
                        style={{ marginBottom: '10px' }}
                    >
                        Добавить владельца
                    </button>
                </Col>
            </Row>
            <OfficeOwnerList owners={owners} onEdit={handleOpenModal} ownerError={ownerError} />
            <OfficeOwnerFormModal
                show={showModal}
                handleClose={handleCloseModal}
                onSubmit={handleSubmit}
                currentId={currentId}
                formItem={formItem}
                setFormItem={setFormItem}
            />
        </MainContainer>
    );
};

export default OfficeOwnerPage;